import type { ScheduledWorkflowDeliverableListItem, ScheduledWorkflowSchedule } from "resources/scheduled-workflows/types"
import { formatSchedule } from "./schedule-format"

export function reportEntryLabel(deliverable: ScheduledWorkflowDeliverableListItem, viewerZone: string): string {
  const createdAt = new Date(deliverable.createdAt)
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: viewerZone, weekday: "short", month: "short", day: "numeric" }).formatToParts(createdAt)
  const partValue = (type: string) => parts.find((part) => part.type === type)?.value
  const clockTime = new Intl.DateTimeFormat("en-US", { timeZone: viewerZone, hour: "numeric", minute: "2-digit" }).format(createdAt)
  return `${deliverable.workflowName} — ${partValue("weekday")} ${partValue("month")} ${partValue("day")}, ${clockTime}`
}

interface ReportSourceLine {
  before: string
  workflowName: string
  after: string
}

export function reportSourceLine(workflowName: string, schedule: ScheduledWorkflowSchedule, viewerZone: string, now: Date): ReportSourceLine {
  const base = { before: "From your ", workflowName, after: " workflow" }
  return schedule == null ? base : { ...base, after: `${base.after} · ${formatSchedule(schedule, viewerZone, { now })}` }
}
